import { Component, Output, ElementRef, TemplateRef, ViewContainerRef, ViewChild, ComponentFactoryResolver, Type, Injector, InjectionToken, OnDestroy, OnInit } from '@angular/core';

import { DialogService } from '../../../common/services/dialog.service';
import { SidePanelService } from "../../../common/services/side-panel.service";

import { ModifyOtherWorkFlowContext } from './sideeffects/side-effect-modify-other-workflow-context.component';
import { SideEffectSaveDatabaseComponent } from './sideeffects/side-effect-savedatabase.component';
import { SideEffectLoadDatabaseComponent } from './sideeffects/side-effect-loaddatabase.component';
import { SideEffectEmailComponent } from './sideeffects/side-effect-email.component';
import { SideEffectLetterComponent } from './sideeffects/side-effect-letter.component';
import { SideEffectCreateWellComponent } from './sideeffects/side-effect-create-well-gis-data.component';
import { SideEffectHoldComponent } from './sideeffects/side-effect-hold.component';
import { SideEffectReviewTasksComponent } from './sideeffects/side-effect-review-tasks.component';
import { SideEffectCompleteWorkItemComponent } from './sideeffects/side-effect-complete-work-item.component';
import { SideEffectReturnWorkItemComponent } from './sideeffects/side-effect-return-work-item.component';
import { SideEffectContactDataComponent } from './sideeffects/contact-data/side-effect-contact-data.component';
import { SideEffectModifyEntityFieldValueComponent } from './sideeffects/side-effect-modify-existing-entity-field-value';
import { SideEffectFetchFASummaryValuesComponent } from './sideeffects/side-effect-fetch-FASummaryValues.component';
import { SideEffectStartAnotherWorkFlowComponent } from './sideeffects/side-effect-start-another-workflow.component';
import { SideEffectAssignToScanningComponent } from './sideeffects/side-effect-assign-to-scanning.component';
import { SideEffectTransformContext } from './sideeffects/side-effect-transform-context.component';
import { SideEffectInvokeTransition } from './sideeffects/side-effect-invoke-transition.component';
import { SideEffectCommitDocsComponent } from './sideeffects/side-effect-commit-docs.component';
import { SideEffectGenerateIdentifierComponent } from './sideeffects/side-effect-generate-identifier.component';
import { SideEffectCreateContactComponent } from './sideeffects/side-effect-create-contact.component';
import { SideEffectGenerateRegistrationCodeComponent } from './sideeffects/side-effect-generate-registration-code.component';
import { SideEffectAssignComponent } from './sideeffects/side-effect-assign.component';
import { SideEffectChangeWellOwnerComponent } from './sideeffects/side-effect-change-well-owner.component';
import { SideEffectCancelPermitComponent } from './sideeffects/side-effect-cancel-permit/side-effect-cancel-permit.component';
import { SideEffectGenerateWellApiComponent } from './sideeffects/side-effect-generate-well-api/side-effect-generate-well-api.component';
import { SideEffectDetermineWellFAOrganizationIdComponent } from './sideeffects/side-effect-determine-well-faorganizationid';
import { SideEffectOrganizationComponent } from './sideeffects/side-effect-organization/side-effect-organization.component';
import { SideEffectDeleteNotificationComponent } from './sideeffects/side-effect-delete-notification/side-effect-delete-notification.component';
import { SideEffectSendNotificationComponent } from './sideeffects/side-effect-send-notification/side-effect-send-notification.component';
import { SideEffectSetDueDtAndApproveDtComponent } from './sideeffects/side-effect-set-DueDtAndApproveDt.component';

import { FlowTemplate, GenerateIdentifierConfig, LoadFromDatabaseConfig, SaveDataConfig, SideEffect, SideEffectType, Transition, Rule, StateType } from "../../../common/models/flow.dto";
import { genId } from "../../../core/services/genId";
import { SIDE_EFFECT_DATA_TOKEN } from './sideeffects/models/types';
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { SideEffectCancelOrgComponent } from './sideeffects/side-effect-cancel-org/side-effect-cancel-org.component';
import { SideEffectCreateOrganizationHistoryEntryComponent } from './sideeffects/side-effect-create-organization-history-entry/side-effect-create-organization-history-entry.component';
import { SideEffectGenerateUncountedIdentifiersComponent } from './sideeffects/side-effect-generate-uncounted-identifiers/side-effect-generate-uncounted-identifiers.component';
import { SideEffectKickOffChiefsOrderComponent } from './sideeffects/side-effect-kick-off-chiefs-order/side-effect-kick-off-chiefs-order.component';
import { SideEffectReplaceBondingComponent } from "./sideeffects/side-effect-replace-bonding/side-effect-replace-bonding.component";
import { TransitionEditorEvent, TransitionEditorEventType } from "../../models/editor.model";
import { SideEffectReleaseFinancialAssuranceComponent } from './sideeffects/side-effect-release-financial-assurance.component';

@Component({
    selector: 'workflow-transition-editor',
    templateUrl: './workflow-transition-editor.component.html',
    providers: [DialogService],
    standalone: false
})
export class WorkflowTransitionEditorComponent extends SidePanelBase implements OnInit {
  static componentName = 'WorkflowTransitionEditorComponent';
  public _seConfiguration: any;
  public _transition: Transition;
  public _selectedSideEffect: SideEffect;
  public _transitionName: string = "";
  public _uneditedSelectedSideEffect: SideEffect;
  public preEditTransitionName: string;
  public selectedSideEffectIndex: number = -1;
  public showDuplicateNameWarning: boolean = false;
  public sideEffects = SideEffectType;
  public selSideEffectTypeOptions: SideEffectOptions = [
    { id: SideEffectType.Unassigned, text: "..." },
    { id: SideEffectType.SaveToDatabase, text: "Save to Database", settings: [SideEffectSaveDatabaseComponent] },
    { id: SideEffectType.LoadFromDatabase, text: "Load from Database", settings: [SideEffectLoadDatabaseComponent] },
    { id: SideEffectType.Email, text: "Email", settings: [SideEffectEmailComponent] },
    { id: SideEffectType.Letter, text: "Letter", settings: [SideEffectLetterComponent] },
    { id: SideEffectType.Hold, text: "Hold", settings: [SideEffectHoldComponent] },
    { id: SideEffectType.ReviewTasks, text: "Add Review Work Items", settings: [SideEffectReviewTasksComponent] },
    { id: SideEffectType.CompleteWorkItem, text: "Complete Current Work Item", settings: [SideEffectCompleteWorkItemComponent] },
    { id: SideEffectType.ReturnWorkItem, text: "Return Current Work Item", settings: [SideEffectReturnWorkItemComponent] },
    { id: SideEffectType.CancelAssociatedWorkItems, text: "Cancel Associated Work Items", settings: [] },
    { id: SideEffectType.RejectToPrevious, text: 'Reject to Previous Step', settings: [SideEffectReviewTasksComponent] },
    { id: SideEffectType.CommitDocuments, text: "Upload All Workflow Files to DMS", settings: [SideEffectCommitDocsComponent] },
    { id: SideEffectType.GenerateIdentifier, text: 'Generate Flow Identifier', settings: [SideEffectGenerateIdentifierComponent] },
    { id: SideEffectType.UploadPdf, text: 'Save PDF to Document Management', settings: [] },
    { id: SideEffectType.GenerateRegistrationCode, text: 'Generate Registration Code', settings: [SideEffectGenerateRegistrationCodeComponent] },
    { id: SideEffectType.CreateContact, text: 'Create/Update Contact', settings: [SideEffectCreateContactComponent] },
    { id: SideEffectType.AssignToScanning, text: "Assign to Scanning", settings: [SideEffectAssignToScanningComponent] },
    { id: SideEffectType.StartAnotherWorkFlow, text: "Kick off another work flow from current", settings: [SideEffectStartAnotherWorkFlowComponent] },
    { id: SideEffectType.ModifyOtherWorkFlowContext, text: "Modify other work flow context", settings: [ModifyOtherWorkFlowContext] },
    { id: SideEffectType.FetchFASummaryResults, text: 'Fetch Financial Assurance Summary Results', settings: [SideEffectFetchFASummaryValuesComponent] },
    { id: SideEffectType.TransformContext, text: 'Transform Workflow Context', settings: [SideEffectTransformContext] },
    { id: SideEffectType.InvokeTransitionOnOtherWorkflow, text: "Invoke a transition on another flow", settings: [SideEffectInvokeTransition] },
    { id: SideEffectType.SaveValueToEntityField, text: "Save a specified value off to a given field in an existing entity instance", settings: [SideEffectModifyEntityFieldValueComponent] },
    { id: SideEffectType.LoadContactData, text: "Load User Information", settings: [SideEffectContactDataComponent] },
    { id: SideEffectType.ChangeWellOwner, text: "Change the owner of the wells specified", settings: [SideEffectChangeWellOwnerComponent] },
    { id: SideEffectType.CancelPermit, text: "Cancel Permit", settings: [SideEffectCancelPermitComponent] },
    { id: SideEffectType.GenerateWellApi, text: "Generate Well API#", settings: [SideEffectGenerateWellApiComponent] },
    { id: SideEffectType.CreateWellFeature, text: "Create Well GIS Features", settings: [SideEffectCreateWellComponent] },
    { id: SideEffectType.DetermineWellFAOrganizationId, text: "Financial Assurance: Make sure to set FAOrganizationIDs on org wells if needed (Well transfer)", settings: [SideEffectDetermineWellFAOrganizationIdComponent] },
    { id: SideEffectType.LoadOrganization, text: "Load Organization", settings: [SideEffectOrganizationComponent] },
    { id: SideEffectType.DeleteNotification, text: "Delete Notification", settings: [SideEffectDeleteNotificationComponent] },
    { id: SideEffectType.SendNotification, text: "Send Notification", settings: [SideEffectSendNotificationComponent] },
    { id: SideEffectType.SetDueDtAndApproveDt, text: "Set Application Due Date and Approve Date", settings: [SideEffectSetDueDtAndApproveDtComponent] },
    { id: SideEffectType.AssignAllOrgContactsToGroup, text: "Cancel an Org and assign all their contacts to a Group", settings: [SideEffectCancelOrgComponent] },
    { id: SideEffectType.CreateOrganizationHistoryEntry, text: "Create a History Entry for an Organization", settings: [SideEffectCreateOrganizationHistoryEntryComponent] },
    { id: SideEffectType.GenerateUncountedIdentifiers, text: "Generate Uncounted Identifiers", settings: [SideEffectGenerateUncountedIdentifiersComponent] },
    { id: SideEffectType.KickOffChiefsOrder, text: "Kick off Chief's Order", settings: [SideEffectKickOffChiefsOrderComponent] },
	  { id: SideEffectType.ReplaceBonding, text: "Replace Bonding", settings: [SideEffectReplaceBondingComponent] },
	  { id: SideEffectType.ReleaseFinancialAssurance, text: "Release Financial Assurance", settings: [SideEffectReleaseFinancialAssuranceComponent] }
  ].sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0);
  public _sideEffectList = new Array<SideEffect>();
    public index: number;

    newFormType: StateType;

    runConditionExpanded: boolean = true;

  @ViewChild('portal', { read: ViewContainerRef, static: true }) public sideEffectSettingsContainer: ViewContainerRef;

  get transition(): Transition {
    return this.componentData.transition;
  }

  set transition(value: Transition) {
    this._transition = value;
    this._transitionName = value.name;
    this._transition.sideEffects = this._transition.sideEffects.sort((x, y) => y.runOrder - x.runOrder);
    //if all the side-effects lack an order
    if (this._transition.sideEffects && this._transition.sideEffects.filter(s => !s.runOrder).length == this._transition.sideEffects.length) {
      for (let i: number = 0; i < this._transition.sideEffects.length; i++) {
        this._transition.sideEffects[i].runOrder = i + 1;
      }
    }
    }

    clonePreceding: boolean = false;

    private stateTypeOptions: StateType[] = [StateType.Undefined, StateType.InputForm, StateType.ReviewForm ];
    private _insertListOptions: any[] = [];

    get insertableStateTypes(): any[] {
        if (this._insertListOptions.length > 0) return this._insertListOptions;
        for (let o = 0; o < this.stateTypeOptions.length; o++) {
            let description = "-- Select --";
            if (this.stateTypeOptions[o].length > 0) {
                let formIndex = this.stateTypeOptions[o].indexOf('Form')
                description = this.stateTypeOptions[o].substring(0, formIndex);
                description = description.substring(0, 1).toUpperCase() + description.substring(1, description.length);
            }
            this._insertListOptions.push({ type: this.stateTypeOptions[o], description: description });
        }
        return this._insertListOptions;
    }

  get sideEffectList() {
    return this.transition.sideEffects;
  }

  get activeTemplate(): FlowTemplate {
    return this.componentData.template;
  }

  constructor(
    public el: ElementRef,
    public dialogService: DialogService,
    public sidePanelService: SidePanelService,
    public _injector: Injector,
    public _componentFactory: ComponentFactoryResolver
  ) {
    super();
    }

    ngOnInit() {
        this.newFormType = StateType.Undefined;
    }

  get seConfiguration() {
    return this._seConfiguration || {};
  }

  set seConfiguration(value) {
    this._seConfiguration = value;
  }

  get selectedSideEffect(): SideEffect {
    if (this._selectedSideEffect === null || this._selectedSideEffect === undefined || this._selectedSideEffect.configuration === undefined || this._selectedSideEffect.configuration === null) {
      return <SideEffect>{ label: '', configuration: {}, implementationType: SideEffectType.Unassigned };
    } else {
      return this._selectedSideEffect;
    }
  }

  set selectedSideEffect(value: SideEffect) {
    this._selectedSideEffect = value;
  }

  get showConfigurationEditor() {
    return this.selectedSideEffectIndex != -1;
  }

  get transitionName(): string {
    return this.componentData.transition.name || '';
  }

  public addSideEffect(): void {
    const se = this.getNewSideEffect();
    let length = this.sideEffectList.push(se);
    this.setSelectedSideEffect(length - 1);
  }

  public cancelChanges(): void {
    this.resetSideEffect();
  }

  public makeEarlier(i: number): void {
    var first = this.transition.sideEffects[i - 1];
    var second = this.transition.sideEffects[i];
    var firstOrder = first.runOrder;
    var secondOrder = second.runOrder;
    first.runOrder = secondOrder;
    second.runOrder = firstOrder;
    this.transition.sideEffects[i - 1] = second;
    this.transition.sideEffects[i] = first;
  }

  public makeLater(i: number): void {
    var first = this.transition.sideEffects[i + 1];
    var second = this.transition.sideEffects[i];
    var firstOrder = first.runOrder;
    var secondOrder = second.runOrder;
    first.runOrder = secondOrder;
    second.runOrder = firstOrder;
    this.transition.sideEffects[i + 1] = second;
    this.transition.sideEffects[i] = first;
  }

  public closeClick(e: Event): void {
    if (this.showDuplicateNameWarning) {
      this.transition.name = this.preEditTransitionName;
      this.showDuplicateNameWarning = false;
    }
    this.selectedSideEffect =
      <SideEffect>{ label: '', configuration: {}, implementationType: SideEffectType.Unassigned };
    this.selectedSideEffectIndex = -1;
    this.sidePanelService.toggleSidePanel(false);
  }

  get componentData(): any {
    if (!this._componentData) {
      this._componentData = {
        transition: <Transition>{
          name: "",
          fromStateKey: null,
          toStateKey: null,
          gojsKey: null,
          targetState: null,
          key: null,
          sideEffects: null,
          outgoingRules: null,
        }
      };
    }

    return this._componentData;
  }

  set componentData(data: any) {
    this._componentData = data;
  }

  //deep TS/JS copy with ref
  public deepClone(obj): any {

    if (typeof (obj) !== 'object' || obj === null) {
      return obj;
    }

    let clone;
    if (Array.isArray(obj)) {
      clone = obj.slice();  // unlink Array reference.
    } else {
      clone = Object.assign({}, obj); // Unlink Object reference.
    }

    let keys = Object.keys(clone);
    for (let i = 0; i < keys.length; i++) {
      clone[keys[i]] = this.deepClone(clone[keys[i]]); // recursively unlink reference to nested objects.
    }

    return clone;
  }

  public deleteSideEffect(index: number): void {
    this.index = index;
    this.dialogService.openDialog("yesNo", "Are you sure you want to delete this Action?");
  }

  public getNewSideEffect(): SideEffect {
    return <SideEffect>{
      id: genId(),
      label: "new",
      configuration: {},
      implementationType: SideEffectType.Unassigned,
      runOrder: this.transition.sideEffects.length + 1
    }
  }

  public hasDuplicateTransitionName(newTransitionName: string): boolean {
    for (let s = 0; s < this.activeTemplate.states.length; s++) {
      let st = this.activeTemplate.states[s];
      for (let t = 0; t < st.transitions.length; t++) {
        let trns = st.transitions[t];
        if (trns != this.transition && trns.name == newTransitionName) {
          return true;
        }
      }
    }
    return false;
  }

  public implementationTypeChanged(): void {
    this.selectedSideEffect.configuration = {};
    this.seConfiguration = this.selectedSideEffect.configuration;
    this.setEditorInterface();
    }

    insertForm(): void {
        if (this.newFormType == StateType.Undefined) return;
        this.saveMethod.emit({ eventType: TransitionEditorEventType.FormInserted, formType: this.newFormType, cloneForm: this.clonePreceding } as TransitionEditorEvent);
        this.clonePreceding = false;
        this.newFormType = StateType.Undefined;
    }

  public isSelectedIndex(testIndex): boolean {
    return testIndex === this.selectedSideEffectIndex;
  }

  public resetSideEffect(): void {
    this.selectedSideEffect = { label: '', configuration: {}, implementationType: SideEffectType.Unassigned, runCondition: null };
    this.setEditorInterface();
  }

  public runOnceChanged(checked: boolean): void {
    this.selectedSideEffect.runOnce = checked;
    if (checked) {
      this.selectedSideEffect.hasRunIndicator = '$.data.' + genId();
    } else {
      this.selectedSideEffect.hasRunIndicator = null;
    }
  }

  public saveChanges(): void {
    if (!this.transition.sideEffects)
      this.transition.sideEffects = new Array<SideEffect>();

    const existing = this.transition.sideEffects.find(se => se.id === this.selectedSideEffect.id);

    if (existing) {
      const tmpList = this.transition.sideEffects.filter(x => x.id !== this.selectedSideEffect.id);
      this.transition.sideEffects = tmpList;
      this.transition.sideEffects.forEach((x, idx) => { x.runOrder = idx; });
    };

    this.selectedSideEffect.runOrder = this.transition.sideEffects.length + 1;
    this.transition.sideEffects.push(this.selectedSideEffect);


    this.resetSideEffect();
  }

  public setEditorInterface(): void {
    switch (this.selectedSideEffect.implementationType) {
      case SideEffectType.SaveToDatabase:
        {
          if (!this.selectedSideEffect.configuration.entityMapIds) {
            this.selectedSideEffect.configuration = { entityMapIds: [] } as SaveDataConfig;
          }
          break;
        }
      case SideEffectType.LoadFromDatabase:
        {
          if (!this.selectedSideEffect.configuration.entityMapIds) {
            this.selectedSideEffect.configuration = { entityMapIds: [] } as LoadFromDatabaseConfig;
          }
          break;
        }
      case SideEffectType.RejectToPrevious:
      case SideEffectType.ReviewTasks:
        {
          if (!this.selectedSideEffect.configuration.reviews) {
            this.selectedSideEffect.configuration = { reviews: [] };
          }
          break;
        }

      case SideEffectType.GenerateIdentifier: {
        if (!this.selectedSideEffect.configuration.identifierType) {
          this.selectedSideEffect.configuration = { identifierType: "none", contextTarget: "$.flowIdentifier" } as GenerateIdentifierConfig;
        }
        break;
      }
      case SideEffectType.AssignToScanning: {
        if (!this.selectedSideEffect.configuration.group) {
          this.selectedSideEffect.configuration = { timeFrame: 90, group: "-1" };
        }
        break;
      }
      case SideEffectType.CommitDocuments: {
        if (!this.selectedSideEffect.configuration.organizationSource) {
          this.selectedSideEffect.configuration = { organizationSource: "flowCreator", organizationIdContext: "", organizationNameContext: "" };
			}
			break;
      }
      case SideEffectType.TransformContext: {
        if (!this.selectedSideEffect.configuration.transforms) {
          this.selectedSideEffect.configuration.transforms = [];
			}
			break;
		}
		case SideEffectType.ReleaseFinancialAssurance: {
			if (!this.selectedSideEffect.configuration.dateSources) {
				this.selectedSideEffect.configuration.dateSources = [];
				this.selectedSideEffect.configuration.organizationId = "$.organizationId";
			}
			break;
		}
      default:
        break;
    }

    let obj = this.selSideEffectTypeOptions.find(x => x.id === this.selectedSideEffect.implementationType);
    this.createSideEffectSettings(obj);
  }

  public setSelectedSideEffect(index: number) {
    this.selectedSideEffectIndex = index;
    this.selectedSideEffect = this.transition.sideEffects[this.selectedSideEffectIndex];
    this._uneditedSelectedSideEffect = this.deepClone(this.selectedSideEffect);  //create clone for cancel button
    this.seConfiguration = this.selectedSideEffect.configuration;
    this.setEditorInterface();
  }

  public transitionNameChange(e: any): void {
    if (!this.hasDuplicateTransitionName(e)) {
      this.showDuplicateNameWarning = false;
        this.saveMethod.emit({ eventType: TransitionEditorEventType.NameChanged, transitionName: this.transition.name } as TransitionEditorEvent);
      //update previously edited value (change happens while user is typing the name)
      this.preEditTransitionName = e;
    } else {
      this.showDuplicateNameWarning = true;
    }
  }

  public createSideEffectSettings(obj: SideEffectOption): void {
    this.sideEffectSettingsContainer.clear();
    if (!obj || !obj.settings)
      return;

    let data = {
      transition: this.transition,
      sideEffect: this.selectedSideEffect,
      configuration: this.seConfiguration,
      template: this.activeTemplate
    };

    obj.settings.forEach(x => {
      let factory = this._componentFactory.resolveComponentFactory(x);
      this.sideEffectSettingsContainer.createComponent(factory, null, this.createInjector(this._injector, data))
    });
  }

  public createInjector(injector: Injector, data: any): Injector {
    return Injector.create([{
      provide: SIDE_EFFECT_DATA_TOKEN, useValue: data
    }], injector);
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    //was the active side effect deleted?
    if (this.index === this.selectedSideEffectIndex) {
      //reset vars
      this.selectedSideEffectIndex = -1;
      this.selectedSideEffect = { label: '', configuration: {}, implementationType: SideEffectType.Unassigned, runCondition: null };
      this.sideEffectSettingsContainer.clear();
      //hide secondary editors

    }
    //remove side effect
    this.transition.sideEffects.splice(this.index, 1);
    this.transition.sideEffects.forEach((x, idx) => { x.runOrder = idx });
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
    }

    runConditionRuleChanged(rule: Rule): void {
        if (rule != null) {
            this.selectedSideEffect.runCondition = rule.expression;
        }        
    }
}

type SideEffectOption = { id: SideEffectType, text: string, settings?: Type<any>[] };
type SideEffectOptions = SideEffectOption[];
